export default {
  momentLocale: 'ja',
  Timeline: {
    expand: '開く',
    fold: '閉じる',
  },
  Balloon: {
    close: '閉鎖する',
    confirm: '確定',
    cancel: 'キャンセル',
  },
  Card: {
    expand: '開く',
    fold: '閉じる',
  },
  Calendar: {
    today: '本日',
    now: '現在',
    ok: '確定',
    clear: 'クリア',
    month: '月',
    year: '年',
    prevYear: '前の年',
    nextYear: '次の年',
    prevMonth: '前の月',
    nextMonth: '来月',
    prevDecade: '前の12年',
    nextDecade: '後12年',
    yearSelectAriaLabel: '年を選んで',
    monthSelectAriaLabel: '月を選択し',
    format: {
      months: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      shortMonths: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
      shortWeekdays: '日_月_火_水_木_金_土'.split('_'),
      veryShortWeekdays: '日_月_火_水_木_金_土'.split('_'),
      yearLabel: 'YYYY 年',
    },
  },
  DatePicker: {
    placeholder: '日付けの選択',
    datetimePlaceholder: '日時を選択してください',
    monthPlaceholder: '月を選択してください',
    yearPlaceholder: '年を選択してください',
    now: '現在',
    selectTime: '時間の選択',
    selectDate: '日付けの選択',
    ok: '確定',
    clear: 'クリア',
    startPlaceholder: '開始日',
    endPlaceholder: '最終日',
    hour: '時',
    minute: '分',
    second: '秒',
  },
  Dialog: {
    close: '閉鎖する',
    ok: '確定',
    cancel: 'キャンセル',
  },
  Message: {
    closeAriaLabel: '閉鎖する',
  },
  Pagination: {
    goTo: '行きます',
    page: 'ページへ',
    total: '第{current}ページ、{total}ページ',
    labelPrev: '前のページ、当面の第{current}ページ',
    labelNext: '次のページ、当面の第{current}ページ',
    inputAriaLabel: '数ページまでジャンプしてください',
    selectAriaLabel: 'ページごとに数本表示してください',
    pageSize: '条/ページ',
  },
  Input: {
    clear: 'クリア',
  },
  Select: {
    selectPlaceholder: '選択',
    autoCompletePlaceholder: '入力',
    notFoundContent: '選択肢なし',
    maxTagPlaceholder: '選択済み {selected}/{total}',
  },
  Table: {
    empty: 'データなし',
    ok: '確定',
    reset: 'リセット',
    asc: '昇順',
    desc: '降順',
    expanded: '展開している',
    folded: '収まった',
    filter: 'フィルタ',
    selectAll: '全選',
  },
  TimePicker: {
    placeholder: '時間の選択',
    startPlaceholder: '開始時間',
    endPlaceholder: '終了時間',
    clear: 'クリア',
    hour: '時',
    minute: '分',
    second: '秒',
  },
  Transfer: {
    items: '項目',
    item: '項目',
    moveAll: '全ての移動',
    searchPlaceholder: '入力',
    moveToLeft: '選択した要素のチェックを外します',
    moveToRight: '選択した要素を送信',
  },
  Upload: {
    card: {
      cancel: 'キャンセル',
      addPhoto: '画像アップロード',
      download: 'ダウンロード',
      delete: '削除',
    },
    drag: {
      text: '枠にドラッグしてアップロード',
      hint: 'docx, xls, PDF, rar, zip, PNG, JPG 等がサポートしています',
    },
    upload: {
      delete: '削除',
    },
  },
  Search: {
    buttonText: 'サーチ',
  },
  Tag: {
    delete: 'デリート',
  },
  Rating: {
    description: '評価オプション',
  },
};
